// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__1XRgj","counter__button":"styles_counter__button___P7sb","counter__button_grey":"styles_counter__button_grey__ho__3","disabled":"styles_disabled__ZfJAu"};